import React from "react";

import {ModalTrigger, ModalTriggerProps} from "@components/modals";

import DishDetailsModal, {DishDetailsModalProps} from "./DishDetailsModal";
import styles from "./DishDetailsModal.scss";

type DishDetailsModalTriggerProps = Omit<
  ModalTriggerProps,
  "modalComponent" | "modalClassName"
> &
  DishDetailsModalProps & {
    children: JSX.Element;
    isInitiallyOpen?: boolean;
  };

export default function DishDetailsModalTrigger(
  props: DishDetailsModalTriggerProps
): JSX.Element {
  return (
    <ModalTrigger
      {...props}
      modalComponent={DishDetailsModal}
      modalClassName={styles.modal}
      closeButtonClassName={styles.closeButton}
    />
  );
}
